import { DEFAULT_ORDER } from './pagination_constants';

let PAGINATION_STATE = new Proxy(
  {
    resourceIDs: [],
    prevResourceIDs: [],
    currentPageResourceIDs: [],
    nextResourceIDs: [],
    currentPage: 1,
    order: DEFAULT_ORDER,
    initialResourceIDs: [],
    idsToAppend: [],
    date: null,
    idsWithoutPrice: []
  },
  {
    get: function (state, field) {
      return state[field];
    },
    set: function (state, field, data) {
      if (field === 'resourceIDs') {
        state.currentPageResourceIDs = data[state.currentPage - 1] || [];
        state.nextResourceIDs = data[state.currentPage];
        state.resourceIDs = data;
        state.currentPage = 1;
      }
      else if (field === 'currentPage') {
        state.currentPage = data;
        if (state.currentPageResourceIDs.length) {
          state.currentPageResourceIDs = state.resourceIDs[state.currentPage - 1] || [];
          state.prevResourceIDs = state.resourceIDs[state.currentPage - 2];
          state.nextResourceIDs = state.resourceIDs[state.currentPage];
        }
      }
      else if (field === 'order' && typeof data === 'string') {
        state.order = data;
      }
      else if (field === 'initialResourceIDs' && typeof data === 'object') {
        state.initialResourceIDs = data;
      }
      else if (field === 'idsToAppend') {
        state.idsToAppend = data;
      }
      else if (field === 'idsWithoutPrice') {
        state.idsWithoutPrice = data;
      }
      else if (field === 'date') {
        state.date = data;
      }
      else {
        console.warn(`Invalid PaginationState: You can not modify property ${field} of type ${typeof data}`);
      }

      return state[field];
    }
  }
);

export default PAGINATION_STATE;
